import { CreateDateFilter } from "src/app/application/applications.component";
import { IDateOption } from "src/app/search/models/date-option.interface";

export class AllDatesAuditLog implements IDateOption {
  option = "All Dates";

  get query(): string {
    return " logId >: 0 ";
  }
}
